import { render } from "./Statistic.vue?vue&type=template&id=3eedbe3a&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import "./Statistic.vue?vue&type=style&index=0&id=3eedbe3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3eedbe3a"

export default script